import useOnMount from '@lib/use-on-mount'
import { IOrganization } from '@mealime/mealime-api-client'
import { ISceneProps } from '@util/types'
import { useLoader } from '@util/ui'
import Cookies from 'js-cookie'
import * as React from 'react'
import { useState } from 'react'
import Loading from 'src/app/loading'
import Layout from '../../util/layout'
import * as Organization from './../../util/organization'
import BenefitOffer from './benefit-offer'
import NoOrganization from './no-organization'
import plates from './offer.png'
import PerkOffer from './perk-offer'

const OfferScene: React.FC<ISceneProps> = ({ navigator }) => {
  // TrackViewAnonymous can be found in OfferBenefit and NoOrganization components
  const [organization, setOrganization] = useState<IOrganization | undefined>()
  const loader = useLoader()
  const org = Cookies.getJSON('organization')

  useOnMount(
    async () =>
      await loader.run(async () => {
        const organization = await Organization.set(org.code)
        setOrganization(organization)
      })
  )

  const handleCreateAccount = (hasAccount: boolean) => {
    navigator.go(import('../menu'), {})
  }

  const handleLinkAccount = (hasAccount: boolean) => {
    navigator.go(import('../link-account'), {})
  }

  const renderContent = () => {
    if (organization?.type === 'benefit') {
      return (
        <BenefitOffer
          organization={organization.name}
          onLinkAccount={() => handleLinkAccount(true)}
          onCreateAccount={() => handleCreateAccount(true)}
        />
      )
    }
    if (organization?.type === 'perk') {
      return (
        <PerkOffer
          organization={organization}
          onCreateAccount={() => handleCreateAccount(true)}
        />
      )
    } else {
      return (
        <NoOrganization onCreateAccount={() => handleCreateAccount(true)} />
      )
    }
  }

  if (loader.isLoading) {
    return <Loading />
  }

  return (
    <Layout
      artAndCopy={
        <img
          src={plates}
          style={{ maxWidth: '100%', width: 600, height: 'auto' }}
          alt="Two plates of dinner."
        />
      }
      actions={<>{organization && renderContent()}</>}
    />
  )
}

export default OfferScene
